export default __webpack_public_path__ + "static/media/DemoFloorPlan.4108b01a.png";